import React from "react";
import { useIsBreeding } from "./hooks/useIsBreeding";
import { Result } from "../../../models/result.model";
import { Test } from "../../../models/test.model";
import { SquareList } from "./components/SquareList";
import { TeamColumn } from "./components/Column";

export type PodiumProps = {
  resultList: Result[];
  test: Test;
  phase: string;
};

export const Podium: React.FC<PodiumProps> = ({ resultList, test, phase }) => {
  const firstPlaces = resultList.filter((r) => r.rank.split(".")[0] === "1");
  const secondPlaces = resultList.filter((r) => r.rank.split(".")[0] === "2");
  const thirdPlaces = resultList.filter((r) => r.rank.split(".")[0] === "3");

  return (
    <div className="square-container">
      <div className="podium-column">
        {secondPlaces.map((entry) => (
          <PodiumColumn
            key={entry.id}
            result={entry}
            test={test}
            color="silver"
          />
        ))}
      </div>
      <div className="podium-column">
        {firstPlaces.map((entry) => (
          <PodiumColumn
            key={entry.id}
            result={entry}
            test={test}
            color="gold"
          />
        ))}
      </div>
      <div className="podium-column">
        {thirdPlaces.map((entry) => (
          <PodiumColumn
            key={entry.id}
            result={entry}
            test={test}
            color="bronze"
          />
        ))}
      </div>
    </div>
  );
};

const colors = {
  gold: "gold",
  silver: "silver",
  bronze: "#CD7F32",
} as const;

const PodiumColumn: React.FC<{
  result: Result;
  test: Test;
  color: keyof typeof colors;
}> = ({ result, test, color }) => {
  const isBreeding = useIsBreeding(test);

  const rank = result.rank.split(".")[0];

  return (
    <SquareList>
      <header>
        <div
          className="color"
          style={{ backgroundColor: colors[color], color: "black" }}
        >
          {rank}
        </div>
        <div>
          {isBreeding ? result.horse?.horseName : result.rider?.fullname}
        </div>
        {result.rider?.team !== "" && (
          <TeamColumn
            team={result.rider?.team ?? ""}
            style={{ marginLeft: "auto" }}
          />
        )}
      </header>
      <main data-show="true">
        <div className="additional-info">
          <div>
            {isBreeding ? result.rider?.fullname : result.horse?.horseName}
          </div>
          <dl>
            <dd>{result.mark}</dd>
          </dl>
        </div>
      </main>
    </SquareList>
  );
};
